module.exports = __webpack_public_path__ + "img/ornament-7923631_1280_thumb.63f46c34.png";